import { faStopCircle } from "@fortawesome/free-regular-svg-icons";
import { faBan, faCheckCircle, faClock, faMicrochip, faPause, faSpinner, faXmarkCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { stopWorkflowExecutionAPI } from "../../service/ai-model.service";
import { useAppContext } from "../../context/app.context";
import { GENERATIVE_AGENT_TYPE } from "../home/dashboard/AddAgentDialog";

const CustomDropdown = (props) => {
  const { options, field, name, value, onChange, hasError, showStop, workflow, showResearch } = props;
  const [toggle, setToggle] = useState(false);
  const { showAlert } = useAppContext();

  const getIcon = (status) => {
    const tool = (<Tooltip className='agent-tooltip'>
      {status}
    </Tooltip>)
    switch (status) {
      case 'SUCCEEDED':
        return <OverlayTrigger placement="top" overlay={tool}><FontAwesomeIcon icon={faCheckCircle} className="text-success" /></OverlayTrigger>
      case 'FAILED':
        return <OverlayTrigger placement="top" overlay={tool}><FontAwesomeIcon icon={faXmarkCircle} className="text-danger" /></OverlayTrigger>
      case 'ACTIVE':
        return <OverlayTrigger placement="top" overlay={tool}><FontAwesomeIcon icon={faPause} className="text-warning" /></OverlayTrigger>
      case 'RUNNING':
        return <OverlayTrigger placement="top" overlay={tool}><FontAwesomeIcon icon={faSpinner} className="" /></OverlayTrigger>
      case 'CANCELLED':
        return <OverlayTrigger placement="top" overlay={tool}><FontAwesomeIcon icon={faBan} color="lightgray" /></OverlayTrigger>
      default:
        return <OverlayTrigger placement="top" overlay={tool}><FontAwesomeIcon icon={faClock} className="text-gray" /></OverlayTrigger>

    }
  }

  const onStopRunning = (e, opt) => {
    e.stopPropagation();
    stopWorkflowExecutionAPI({ name: workflow, executionId: opt.executionId })
      .then(r => showAlert(r?.message || "Stop workflow requested", "error"))
      .catch(e => showAlert(e?.message || "Failed to stop the workflow", "error"))
  }

  const render = () => {
    const selectedOptionLabel = field
      ? options.filter((opt) => opt.id == value)[0]?.[field] || `Select ${name}`
      : options.filter((opt) => opt == value)[0] || `Select ${name}`;

    const tool = (<Tooltip className='agent-tooltip'>Research Agent</Tooltip>)
    return (
      <>
        {name && (
          <div className="custom-dropdown-label text-blue mb-1 capitalize"><b>{name}</b></div>
        )}
        <div className={`select ${hasError ? "border-red" : ""}`}>
          <div
            onClick={() => setToggle(!toggle)}
            className={`select-styled ${toggle ? "active" : ""} capitalize`}
          >
            {selectedOptionLabel}{" "}
          </div>
          <ul
            className={`select-options`}
            style={{ display: toggle ? "block" : "none" }}
          >
            {options.map((opt, index) => (
              <li
                onClick={() => {
                  setToggle(!toggle);
                  onChange(field ? opt.id : opt);
                }}
                key={`dropdown-${index}`}
                rel={opt[field]}
                className={`d-flex align-items-center justify-content-between pr-2 capitalize ${value === (field ? opt.id : opt) ? "is-selected" : ""}`}
              >
                <p className="m-0 p-0 w-80 overflow-hidden text-truncate">{field ? opt[field] : opt}{" "}</p>
                {opt.state && <div className="d-flex justify-content-center align-items-center w-20">
                  {(showStop && opt.state === "ACTIVE") && <p className="p-0 m-0 mx-2"><FontAwesomeIcon icon={faStopCircle} className="text-error pointer-cursor" onClick={e => onStopRunning(e, opt)} /></p>}
                  {opt.state && <p className="p-0 m-0 ml-2">{getIcon(opt.state)}</p>}
                </div>}
                {(showResearch && opt.agent_type === GENERATIVE_AGENT_TYPE.RESEARCH

                ) && <p className="p-0 m-0 w-20 ml-2"> <OverlayTrigger placement="top" overlay={tool}><FontAwesomeIcon icon={faMicrochip} className="text-default" /></OverlayTrigger></p>}
              </li>
            ))}
          </ul>
        </div>
      </>
    );
  };
  return render();
};

export default CustomDropdown;
